import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ConversionStatus, ConversionStatusResponse } from '../../../types/status';
import { RuntimeConfigService } from '../common/runtime-config.service';
import { SKIP_GLOBAL_ERROR_REDIRECT } from '../../utils/http-context-tokens.util';

@Injectable({
  providedIn: 'root'
})
export class ConversionStatusService {
  private readonly config = inject(RuntimeConfigService);
  private readonly http = inject(HttpClient);
  private readonly API_URL = `${this.config.apiUrl()}/mbrs/conversion-status-count`;

  /**
   * Returns aggregate conversion-status counts. The Success count is
   * inherently Phase-2-only — a Phase 1 conversion never reaches Success
   * (BE-confirmed; see the isPhase1/isPhase2 note in src/types/commons.ts).
   * The Review count spans both phases.
   */
  fetchConversionStatusCount(): Observable<ConversionStatus> {
    return this.http
      .get<ConversionStatusResponse>(this.API_URL, {
        withCredentials: true,
        // See SKIP_GLOBAL_ERROR_REDIRECT's own docblock: this call's failure
        // is classified and toasted by page-load-failure.util.ts (the
        // DASHBOARD_SUMMARY scope) — the global interceptor's redirect must
        // not win that race.
        context: new HttpContext().set(SKIP_GLOBAL_ERROR_REDIRECT, true),
      })
      .pipe(map((response) => response.data));
  }
}
